import type {Mapper} from 'framework';
import type {ResolveResult} from '../../domain/resolve-result';
import type {ResolveProductDto} from '../dto/product.dto';
import type {ProductDtoToProductMapper} from './product-dto-to-product.mapper';

export class ResolveDtoToResolveResultMapper implements Mapper<ResolveProductDto, ResolveResult> {
  constructor(private readonly productMapper: ProductDtoToProductMapper) {}

  transform(dto: ResolveProductDto): ResolveResult {
    if (dto.status === 'already_saved') {
      return {
        status: 'already_saved',
        product: this.productMapper.transform(dto.product),
      };
    }
    if (dto.status === 'catalog_match') {
      return {
        status: 'catalog_match',
        match: {
          source: 'open_food_facts',
          barcode: dto.match.barcode,
          productName: dto.match.productName,
          brand: dto.match.brand,
          kcalPer100g: dto.match.kcalPer100g,
          proteinPer100g: dto.match.proteinPer100g,
          carbsPer100g: dto.match.carbsPer100g,
          fatPer100g: dto.match.fatPer100g,
        },
      };
    }
    return {
      status: 'not_found',
      barcode: dto.barcode,
    };
  }
}
